<template>
    <div id="channels-tabs" class="channels-tabs" v-if="checkRole(project.id, 'project:connector:view')">
        <div class="mt-16">
            <h2 class="section-title">Интеграции</h2>
            <v-tabs v-model="activeTab" class="section-tabs my-3">
                <v-tabs-slider color="mainNew"></v-tabs-slider>

                <v-tab>Каналы отправки (Каскад)</v-tab>
                <v-tab>Настройки отправки</v-tab>

                <v-tab>
                    <v-row align="center" class="ma-0">
                        <span>Телефония</span>
                        <HintIcon hintId="telephony" class="ml-2"></HintIcon>
                    </v-row>
                </v-tab>
                <v-tab>
                    <v-row align="center" class="ma-0">
                        <span>Источники данных</span>
                        <HintIcon hintId="connectors" class="ml-2"></HintIcon>
                    </v-row>
                </v-tab>
            </v-tabs>
        </div>
        <v-tabs-items v-model="activeTab" :touchless="$vuetify.breakpoint.smAndDown">
            <v-tab-item>
                <ChannelsTab
                    :project="project"
                    :channels="channels"
                    :allChannelsCards="allChannelsCards"
                    :selectedConnectors="selectedConnectors"
                    :channel-priorities="channelPriorities"
                    @update:selectedConnectors="$emit('update:selectedConnectors', $event)"
                    @openConnectorSettings="$emit('openConnectorSettings', $event)"
                    @openConnectorSettingsInSidebar="$emit('openConnectorSettingsInSidebar', $event)"
                    @deleteConnector="$emit('deleteConnector', $event)"
                    @update-channel-priority="$emit('update-channel-priority', $event)"
                />
            </v-tab-item>
            <v-tab-item>
                <NotificationSettingsSendingSettings :connector="botConnector" />
            </v-tab-item>
            <v-tab-item>
                <TelephonyTab
                    :project="project"
                    :telephonyConnectors="telephonyConnectors"
                    :allTelephonyCards="allTelephonyCards"
                    :selectedConnectors="selectedConnectors"
                    :telephonyView="telephonyView"
                    @update:selectedConnectors="$emit('update:selectedConnectors', $event)"
                    @update:telephonyView="telephonyView = $event"
                    @openConnectorSettings="$emit('openConnectorSettings', $event)"
                    @deleteConnector="$emit('deleteConnector', $event)"
                />
            </v-tab-item>
            <v-tab-item>
                <SourcesTab
                    :project="project"
                    :connectors="connectors"
                    :allSourcesCards="allSourcesCards"
                    :selectedConnectors="selectedConnectors"
                    :connectorsView="connectorsView"
                    @update:selectedConnectors="$emit('update:selectedConnectors', $event)"
                    @add-connector="$emit('add-connector')"
                    @update:connectorsView="connectorsView = $event"
                    @openConnectorSettings="$emit('openConnectorSettings', $event)"
                    @deleteConnector="$emit('deleteConnector', $event)"
                />
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
import { checkRole } from '../../helpers/roles'
import ChannelsTab from './ChannelsTab.vue'
import SourcesTab from './SourcesTab.vue'
import TelephonyTab from './TelephonyTab.vue'
import NotificationSettingsSendingSettings from '@/components/ClientNotifications/NotificationSettingsSendingSettings.vue'
import HintIcon from '@/components/HintIcon'
import { CONNECTOR_TYPES } from '@/vars/general'

export default {
    name: 'ChannelsTabs',

    components: {
        ChannelsTab,
        SourcesTab,
        TelephonyTab,
        NotificationSettingsSendingSettings,
        HintIcon,
    },
    props: {
        project: {
            type: Object,
            required: true,
        },
        channels: {
            type: Array,
            required: true,
        },
        connectors: {
            type: Array,
            required: true,
        },
        allChannelsCards: {
            type: Array,
            required: true,
        },
        telephonyConnectors: {
            type: Array,
            required: true,
        },
        allTelephonyCards: {
            type: Array,
            required: true,
        },
        allSourcesCards: {
            type: Array,
            required: true,
        },
        selectedConnectors: {
            type: Array,
            default: () => [],
        },
        channelPriorities: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            activeTab: 0,
            connectorsView: 'cards',
            channelsView: 'cards',
            telephonyView: 'cards',
        }
    },
    watch: {
        connectorsView() {
            this.$emit('update:selectedConnectors', [])
        },
        channelsView() {
            this.$emit('update:selectedConnectors', [])
        },
        telephonyView() {
            this.$emit('update:selectedConnectors', [])
        },
    },
    computed: {
        botConnector() {
            return this.project.connectors.find(
                (con) => con.connectorType === CONNECTOR_TYPES.whatsappBasis
            )
        },
    },
    methods: {
        checkRole,
        switchToNotificationSettingsTab() {
            this.activeTab = 1 // Индекс вкладки "Настройки отправки"
        },
        switchToChannelsTab() {
            this.activeTab = 0 // Индекс вкладки "Каналы отправки (Каскад)"
        },
    },
    mounted() {
        // Подписываемся на событие переключения на вкладку "Настройки отправки"
        this.$root.$on('switch-to-notification-settings-tab', this.switchToNotificationSettingsTab)
        // Подписываемся на событие переключения на вкладку "Каналы отправки (Каскад)"
        this.$root.$on('switch-to-channels-tab', this.switchToChannelsTab)
    },
    beforeDestroy() {
        // Отписываемся от событий при уничтожении компонента
        this.$root.$off('switch-to-notification-settings-tab', this.switchToNotificationSettingsTab)
        this.$root.$off('switch-to-channels-tab', this.switchToChannelsTab)
    },
}
</script>

<style scoped lang="sass">
@import '@/vars.sass'
.section-title
    font-family: $font-family-base
    font-size: 21px
    font-weight: 900
    letter-spacing: -.025em
    color: $dark-new
    margin: 0
    line-height: 1.2

.channels-tabs
    margin-top: 16px

.section-tabs
    ::v-deep .v-tabs-bar
        min-height: 36px
        border-bottom: none !important

    ::v-deep .v-slide-group__prev,
    ::v-deep .v-slide-group__next
        display: none !important

    ::v-deep .v-tab
        text-transform: none
        font-size: 13px
        font-weight: 500
        color: $muted-new !important
        min-width: auto
        padding: 8px 16px
        letter-spacing: 0
    ::v-deep .v-tab--active
        color: $main-new !important
        font-weight: 500
    ::v-deep .v-tab--active span
        color: inherit !important
    ::v-deep .v-tabs-slider
        height: 2px !important
        border-radius: 0
        background-color: $main-new !important

::v-deep .v-slide-group__content.v-tabs-bar__content
    border-bottom: none !important
</style>

